<template>
  <router-view/>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.StylableButton2545352419__container {
    align-items: center;
    display: flex;
    flex-basis: auto;
    flex-direction: row;
    flex-grow: 1;
    height: 100%;
    justify-content: center;
    overflow: hidden;
    transition: all .2s ease,visibility 0s;
    width: 100%;
}
@import url('https://fonts.googleapis.com/css2?family=Kanit:wght@300;400;700&display=swap');

.banner-container {
  overflow: hidden;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height:150px;
  max-width: 150px;
  top: 0;
  right:0;
  @media only screen and (max-width: 600px) {
    right:-10px;
    top: -10px;
  }
}

.rotate {
  animation: rotate 10s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
#circulo-banner::before {
    content: '';
    background-image: url("@/assets/rotacao-cartao.webp");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 50px;
    height: 50px;
    position: absolute;
    right: 0;
    left: 0;
    margin: 0 auto;
}
text {
  font-size: 19px;
  font-weight: bold;
  text-transform: uppercase;
}

* {
  text-decoration: none;
}
/* .btn {
    background: #D32F2F;
    color: #fff!important;
    padding: 20px 30px !important;
    border-radius: 99px;
    max-width: 20vw !important;
    min-width: 20vw !important;
    margin: 50px;
    animation: pulse 4s infinite, pisca 5s infinite;
    box-shadow: 0 0 21px -6px #D32F2F71;
} */
@keyframes pulse {
    0% {
        transform: scaleX(1)
    }

    50% {
        transform: scale3d(1.05,1.05,1.05)
    }

    to {
        transform: scaleX(1)
    }
}
@keyframes pisca {
    70% {
        box-shadow: 0 0 0 25px transparent
    }

    to {
        box-shadow: 0 0 0 0 transparent
    }
}
.slides-container {
  border-top: 15px solid #FFC107;
  position: relative;
  max-width: 100vw;
  min-width: 100vw;
  left: 0!important;
  height: 600px;
  overflow: hidden
}
.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s ease-in-out;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.slide[style*="display: block;"] {
  opacity: 1;
}

.g4 {
    padding: 0 !important;
    margin: 0 auto !important;
    display: grid;
    max-width: 90% !important;
    @media only screen and (max-width: 600px) {
        max-width:100%!important;
        grid-template-columns: repeat(2,50%)
    }
    P{
      padding-right: 4px;
    }
    grid-template-columns: repeat(4, 25%);
    -moz-column-gap: 5px;
    column-gap: 5px;
    row-gap: 2.5px;
  img {
    max-width: 100% !important;
    min-width: 100% !important;
    width: auto;
    height: auto;
  }
}

.t {
  position: absolute;
  top: 5%;
  left: 6%;
  z-index: 10;
  max-width: 50vw !important;
  min-height: 100% !important;

  * {
    color: #212121 !important;
  }
  .title{
    @media only screen and (max-width: 600px) {
      font-size: 48px;
    }
  }
  @media only screen and (max-width: 600px) {
    left: 5%;
    max-width: 90vw !important;
    min-height: 100% !important;
  }
}

.font-hover {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 2.5rem;
  text-transform: uppercase;
}

.banner-contato {
  display: flex;
  flex-direction: column;
  /* Ajuste conforme necessário */
  gap: 16px;

  /* Espaçamento entre os alvos de toque */
  * {
    color: #fff !important
  }
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 20px 30px;
  margin:20px auto;
  border: none;
  border-radius: 36px;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 600;
  max-width: 25vw !important;

  @media only screen and (max-width: 600px) {
    max-width: 50vw !important;
    min-width: 50vw !important;
    font-size: 0.7rem;
  }

  cursor: pointer;
}

.b1 {
  background: #00CF4B;
  color: white;
  animation: pisca 1.5s infinite;
  box-shadow: 0px 0px 21px -6px #00CF4B;
}

.b2 {
  background-color: darken(#D32F2F, 10%);
  box-shadow: 0px 0px 21px -6px #D32F2F;
  animation: pisca 1.5s infinite;
  color: white;
}

.icon32 {
  margin-right: 8px;
}

.btn:hover {
  background-color: #212121
}

.btn.b2:hover {
  background-color: #212121
}
.servicos{
    display: flex;
    flex-wrap: wrap;
    li {
    min-width: 45%;
    @media only screen and (max-width: 600px) {
        min-width: 100%;
    }
}
}
.footer-content{
    padding: 0 5px;
    p{
      text-align: left!important;
    }
}
.icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 18px;
    margin-right: 5px;
    color: #d5d5d5;
    font-size: 10px;
    text-align: center;
    background-color: #f3f3f6;
    vertical-align: middle;
    border-radius: 50%;
}
.row {
    display: flex;
    position: relative;
    width: 92vw;
    margin: 0 auto!important;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 6px;
    div{
        width: calc((100%/3) - 4px);
        @media only screen and (max-width: 600px) {
            width: 95%;
    }
    }
}
h3 {
    @media only screen and (max-width: 600px) {
            font-size: 28px;
    }
    font-family: "Teko", Sans-serif;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 58px;
    color:#212121
}
.footer-section {
    min-width: 100vw!important;
    max-width: 100vw!important;
    background: #7A7A7A17;
    color: #212121
}

.contact-info{
    min-width: 55%;
    margin: 0 auto!important;
    .icon-text {
    display: flex;
    margin-bottom: 10px;
    color:#212121!important;
}
}

.copyright-area {
    padding: 15px 0;
    color: #212121;
    text-align: center;
    div{
        margin: 0 auto!important;
    }
}
.copyright{
    display: flex;
    justify-content: center;
}
@media (max-width: 767px) {
    .footer-menu {
        margin-top: 30px;
    }
}
.whatsapp-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #00CF4B;
        width: 48px;
        height: 48px;
        padding: 20px;
        font-size: 16px;
        border-radius: 100%;
        text-decoration: none;
        animation: pulse 4s infinite, pisca 1.5s infinite;
        box-shadow: 0px 0px 21px -6px #25D366;
        // animation: pisca 1.5s infinite;
        transition: background-color 0.3s ease;
        position: fixed;
        bottom: 2vh;
        right: 5vw;
        @media only screen and (max-width: 600px) {
        }
        z-index: 1000;
    }

    .whatsapp-button:hover {
        background-color: #2aee72;
    }
</style>
